import { call, put } from 'redux-saga/effects';
import GetCheckAvailableActions from '../redux/GetCheckAvailableRedux';
import { api } from './api';
import { isValidValue } from '../utils/Helpers';

export function* getcheckavailablesagas(action: any): Generator<any, void, any> {
  const { leave_id, student_id, isTherapist, isReschedule, make_id, therapist_leave_id } = action;

  // Choose the correct API call based on parameters (match reference exactly)
  const response = isTherapist || isValidValue(therapist_leave_id)
      ? yield call(
          api.getCheckAvailableTherapist,
          isValidValue(leave_id) ? leave_id : therapist_leave_id,
          student_id
        )
      : yield call(api.getCheckAvailable, leave_id);

  // Make additional API call for reschedule mode (match reference exactly)
  const responseUpdate = isReschedule ? yield call(api.getMake, make_id) : null;

  // success?
  if (response.ok) {
    // Logic to determine allow_option_two based on checked_make_up_session_schedules (match reference exactly)
    let dataAvaible = {
      success: true,
      data: { allow_option_one: true, allow_option_two: true },
    };
    let responseSuccess =
      responseUpdate?.data?.data?.checked_make_up_session_schedules?.length >= 2
        ? dataAvaible
        : response.data;
    
    yield put(
      GetCheckAvailableActions.getCheckAvailableSuccess(responseSuccess)
    );
  } else {
    yield put(GetCheckAvailableActions.getCheckAvailableFailure());
  }
}